const RANKING_ITEMS = [
  {
    rank: 1,
    title: '流浪地球3',
    subtitle: '国产科幻巅峰之作',
    hot: '本周播放量 128万+',
    change: 'up',
    tag: '热播中',
  },
  {
    rank: 2,
    title: '肖申克的救赎',
    subtitle: '豆瓣评分9.7 影史第一',
    hot: '累计播放量 890万+',
    change: 'stable',
    tag: '经典永恒',
  },
  {
    rank: 3,
    title: '星际穿越',
    subtitle: '诺兰科幻神作',
    hot: '本周播放量 96万+',
    change: 'up',
    tag: '高分推荐',
  },
  {
    rank: 4,
    title: '英雄本色',
    subtitle: '港片黄金时代代表作',
    hot: '本周播放量 73万+',
    change: 'up',
    tag: '经典怀旧',
  },
  {
    rank: 5,
    title: '寄生虫',
    subtitle: '奥斯卡最佳影片',
    hot: '累计播放量 520万+',
    change: 'stable',
    tag: '获奖佳作',
  },
];

export default function RankingSection() {
  const rankColors: Record<number, string> = {
    1: 'bg-accent-500 text-foreground-950',
    2: 'bg-primary-500 text-background-50',
    3: 'bg-primary-400 text-background-50',
    4: 'text-foreground-500',
    5: 'text-foreground-500',
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            实时更新的热门影片排行榜，发现大家都在看的国内外大片和最受好评的经典佳作
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 px-4 rounded-lg hover:bg-background-100/60 transition-colors cursor-pointer group border-b border-background-200/20 last:border-b-0"
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  rankColors[item.rank] || 'text-foreground-500'
                } ${item.rank <= 3 ? '' : 'bg-background-100'}`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-background-200/60 text-foreground-500 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.subtitle}</p>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-fill text-green-400 text-xs"></i>}
                {item.change === 'stable' && <i className="ri-subtract-line text-foreground-400 text-xs"></i>}
              </div>

              <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:inline">{item.hot}</span>
            </div>
          ))}
        </div>

        <div className="text-center mt-6">
          <a
            href="#index"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer font-medium"
          >
            查看更多热门影片
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}